// lib
import { Subject } from 'rxjs';

// elvispos
import { Logger } from 'ngx-elvis-ds';
import { JHIMMessage } from '../interfaces/jhim-message';
import { SAMService } from '../../sam/sam.service';
import { BaseWebSocket } from 'src/app/base/websocket';

export class JHIM extends BaseWebSocket {

  messages: Subject<any> = new Subject();
  messagesQueue: any[] = [];

  constructor(
    public sam: SAMService,
  ) {
    super();
  }

  onSend(message: JHIMMessage, source = '') {
    try {
      this.initGUIMessage(message, source);

      if (this.socket && this.socket.readyState === 1) {
        const stringMessage: string = JSON.stringify(message);
        this.socket.send(stringMessage);
        this.events.next('send');
      } else {
        this.messagesQueue.push(message);
      }
    } catch (error) {
      this.events.next('send::error');
      Logger.error('JHIM::WebSocket::onSend', error);
    }
  }

  onError(err: any) {
    this.events.next('error');
    Logger.error('JHIM::WebSocket::onError', err);
  }

  onMessage(event: any) {
    const message = <JHIMMessage>JSON.parse(event.data);
    if (message.Destination === 'SAM') {
      this.sam.socket.send(JSON.stringify(message));
    }
  }

  onOpen(event: any) {
    this.sam.onSend({ Command: 'CMD_SET_JHIM_STATE', parms: { state: 'online' } });
    this.events.next('open');
    Logger.log('JHIM::onOpen', event);

    this.dispatchQueue();
  }

  onClose(event: any) {
    this.sam.onSend({ Command: 'CMD_SET_JHIM_STATE', parms: { state: 'offline' } });
    this.events.next('close');
    Logger.log('JHIM::onClose', event);
  }

  // private

  private initGUIMessage(message, source) {
    message.Source = 'GUI';
  }

  private dispatchQueue() {
    if (this.messagesQueue.length > 0) {
      for (const m of this.messagesQueue) {
        this.socket.send(JSON.stringify(m));
      }
      this.messagesQueue = [];
    }
  }
}
